import { Text } from '@components/index';
import { UnstyledButtonType } from '@components/SearchBars/SearchFigma/types';
import { CategoryColor } from '@models/TagCategory.model';
import { T_TYPOGRAPHY_FLAT } from '@styles/fonts/fontsizes/typography-flat';
import { getDefaultTagBackground } from '@utils/getDefaultTagBackground';
import { cx, getTagFontColor } from '@utils/index';
import { StyledButton } from './Tag.styles';

type UnstyledBtn = Omit<React.ComponentProps<UnstyledButtonType>, 'color'>;

interface ITagComponent extends UnstyledBtn {
  name: string;
  color: CategoryColor | undefined | null;
  icon?: React.ReactNode;
  className?: string;
  text?: keyof T_TYPOGRAPHY_FLAT;
}
export function Tag(props: ITagComponent) {
  const { name, color, icon, text = 'b200', className = '', ...rest } = props;
  const classes = cx('reset-global new-icon', className);
  return (
    <StyledButton
      className={classes}
      bg={getDefaultTagBackground(color ?? undefined)}
      {...rest}
    >
      <Text text={text} c={getTagFontColor(color ?? undefined)}>
        {name}
      </Text>
      {icon}
    </StyledButton>
  );
}
